import { render } from "./Menu.vue?vue&type=template&id=f569fb1c&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=f569fb1c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Setrin\\dev\\NTS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f569fb1c"]])

export default __exports__